import { logoutUser } from "../api/auth";
import * as Sentry from "@sentry/nextjs";

export const fetcher = async (
  url: string,
  data: RequestInit = {},
  retJson = true,
  version: string = 'v1'
): Promise<unknown> => {
  try {
    const fullUrl = `${process.env.NEXT_PUBLIC_API_URL}/${version}/${url}`;
    let responseJson: unknown;
    const response = await fetch(fullUrl, data);

    if (
      !response.url.includes("auth") &&
      response.status === 401 &&
      typeof window != "undefined"
    ) {
      logoutUser();
      return;
    }

    if (retJson) {
      responseJson = await response.json();
    }

    const returnObject = retJson ? responseJson : response;

    if (response.status >= 500) {
      const errorMessage = `Error while calling [${
        data.method ?? "GET"
      }]: ${url}`;
      const error = new Error(errorMessage);

      Sentry.withScope((scope) => {
        scope.setFingerprint([url, data.method ?? "GET", `${response.status}`]);

        Sentry.captureException(error, {
          tags: { endpoint: url, method: data.method ?? "GET" },
          extra: {
            status: response.status,
            response: responseJson ?? null,
            requestBody: data.body ?? null,
          },
        });
      });
    }
    if (!response.ok) {
      throw returnObject;
    }

    return returnObject;
  } catch (error) {
    const errorObject = error as Error;
    console.error(errorObject);

    throw error;
  }
};
